import { ReactNode } from 'react';
import styles from './AccordionTable.module.scss';
import { NoResults } from '@dmc/ui';
import { useTranslation } from 'react-i18next';

interface AccordionTableProps {
  hasRows: boolean;
  children: ReactNode;
  noRowsMessage?: string;
}

export const AccordionTable = ({ hasRows, children, noRowsMessage }: AccordionTableProps) => {
  const { t } = useTranslation();

  const description = typeof noRowsMessage !== 'undefined' ? noRowsMessage : t('No Data');

  return (
    <div className={styles.table}>
      {hasRows ? children : <NoResults description={description} height="100px" />}
    </div>
  );
};

export default AccordionTable;
